import { Component, HostListener, OnInit, OnDestroy } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs";

import { Config } from "src/app/config";
import { ExamService } from "src/app/services/exam.service";
import { AdminAuthService } from "src/app/services/adminauth.service";
import { ModalDialogService } from "src/app/modals/modaldialog/modaldialog.service";
import { AdminUser } from "src/app/models/adminuser";
import { SERVERRESPONSERESULT } from "src/app/models/serverresponse";

@Component({
  selector: "hkt-pageedit",
  templateUrl: "./pageedit.component.html",
  styleUrls: ["./pageedit.component.scss"],
})
export class PageEditComponent implements OnInit, OnDestroy {
  adminUser: AdminUser;
  websiteName: string;
  toolbarMenuActive: string;
  workspaceWidth: number;
  editorHeight: number;
  routerParams: Subscription;
  examId: number;

  constructor(
    private router: Router,
    private adminAuthService: AdminAuthService,
    private examService: ExamService,
    private activatedRoute: ActivatedRoute,
    private modalDialogService: ModalDialogService,
  ) {}

  ngOnInit() {
    this.adminUser = this.adminAuthService.currentUser;
    this.websiteName = Config.APP_NAME;
    this.toolbarMenuActive = "Exams";
    this.onWindowResize(null);

    this.routerParams = this.activatedRoute.params.subscribe(params => {
      this.examId = +params["id"];
      this.examService.loadEditExam(this.examId).subscribe(
        response => {
          if (response == false) {
            this.modalDialogService.showAlert(Config.APP_NAME, "Error loading the exam");
          }
        },
        error => {
          console.error("Error: " + error);
        },
      );
    });
  }

  ngOnDestroy() {
    this.routerParams.unsubscribe();
  }

  @HostListener("window:resize", ["$event"])
  onWindowResize(event) {
    const header = 60;
    const toolbar = 100;
    const bottomPanel = 140;
    this.editorHeight = window.innerHeight - header - toolbar - bottomPanel;
    const sideMargin = 10;
    this.workspaceWidth = window.innerWidth - sideMargin * 2;
  }

  onLogout(): boolean {
    this.adminAuthService.logout().subscribe(response => {
      if (response.result == SERVERRESPONSERESULT.OK) {
        this.router.navigate(["editlogin", this.examId]);
      }
    });
    return false;
  }

  onToolbarExams(): boolean {
    this.toolbarMenuActive = "Exams";
    return false;
  }

  onToolbarEdit(): boolean {
    this.toolbarMenuActive = "Edit";
    return false;
  }

  toggleMenu(): void {}
}
